module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "a07_preface"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "preface"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Preface to First Edition"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#pre_fn1",
      "id": "not_1"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The main theme in this penultimate volume is the Jutland story. It has been told often. My version of necessity emphasizes the role of the British fleet in the battle. It omits many of the minor encounters and much other detail and focuses on the salient features, especially on those which have given rise to conflicting interpretations and partisan warfare.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There has been altogether too much passion and bias in the ‘Jutland Controversy’, more particularly as regards the two British principals. Montagus and Capulets still abound. I am myself neither. Throughout I have made a conscientious attempt to be dispassionate and to eschew ‘the lucid view afforded by hindsight’, for, as Homer put it, ‘After the event even a fool is wise.’ Throughout I have also borne in mind how little those concerned in the battle really knew what was going on. To judge their actions from the comfort of an armchair, with the dispatches, a mass of elaborate and accurate diagrams, and descriptions of the battle from both sides—none of which material, of course, was available to the commanding officers at Jutland—spread out before one, and with an utter disregard of the effects of smoke and mist and of what the C.-in-C. and squadron admirals knew "), _c('i', [_vm._v("at the time")]), _vm._v(" of the High Seas Fleet’s strength, position, and formation, would be unjust to those officers and make a mockery of Clio, the Muse of History. The historian needs also to remember that ship-to-ship directional wireless telegraphy was then in its infancy, that air reconnaissance did not, practically speaking, exist, and that there was no radar. Where possible, I have also endeavoured to soften my criticism by charity for human frailty and by the knowledge that, as Captain John Creswell has so well put it in another context, ‘in the stresses of a great war the Fates are often stronger than man, even man at his best: that an enterprise may fail, and fail disastrously, without the officer responsible for it necessarily deserving castigation.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Some day no doubt Jutland will be understood’, Jellicoe remarked in 1921.1 would like to think that this volume will make "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("a modest contribution to that understanding; but I am under no illusion that I have written the ‘definitive’ history of the battle. The controversial points will be debated as long as history is studied and written, for Jutland is incontrovertible proof of the Dutch historian Pieter Geyl’s dictum concerning historical interpretation: ‘History is indeed an argument without end.’")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The post-Jutland narrative, to December 1916, which constitutes the latter part of this volume, is in some important ways an integral part of the Jutland story. The highlights of the period are the fleet reformation in "), _c('i', [_vm._v("matériel")]), _vm._v(", tactics, and strategy, the action (or near action) of 19 August, the resumption of U-boat warfare in accordance with prize rules, and the change in the high command of the Navy, at Whitehall and in the Grand Fleet. Directly or indirectly, they are all related to Jutland, and they mark the end of a phase in the war at sea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As for materials used, I have consulted all published writings of any value. It has been my good fortune to have had access to an appreciable quantity of restricted or unpublished Jutland material. I would single out here the many fine articles in the privately circulated "), _c('i', [_vm._v("Naval Review")]), _vm._v(", Vice-Admiral K. G. B. Dewar’s trenchant writings (three restricted articles of 1959–60, in particular), which, although uncomplimentary to nearly everybody afloat and ashore who had any connection with the battle, Jellicoe above all, nevertheless have merit; the series of five Jutland lectures delivered at the Naval War College in 1929 by Captain (afterwards Admiral Sir) Bertram H. Ramsay (Jellicoe MSS.); the seven equally moderate and unbiased Jutland lectures, a revision of Ramsay’s given at the Naval Staff College in 1930 by the Deputy-Director, Captain (now Admiral) John H. Godfrey (Naval Historical Library, Ministry of Defence); and the further revised set of seven, delivered at the Naval Staff College in 1932 by Commander (afterwards Admiral Sir) William G. Tennant (Lady Tennant). [National Maritime Museum.] The Staff College lectures were pretty well standardized by 1932.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("To these sources I would add the Naval Staff Monograph, "), _c('i', [_vm._v("Naval Staff Appreciation of Jutland")]), _vm._v(" (1922), by the Dewar brothers, A. C. and K. G. B. (then captains), which is highly critical of Jellicoe’s tactics. Although it must be used with caution (Jellicoe described it as ‘a purely B.C.F. [Battle Cruiser Fleet] account, looked at with B.C.F. eyes’ and ‘a tissue of inaccuracies and false deductions’), it ")]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("does have material not to be found elsewhere and some valuable insights. Beatty, then First Sea Lord, had told the Dewars ‘to bring out the battle’s lessons’. About 300 copies were printed, but the "), _c('i', [_vm._v("Appreciation")]), _vm._v(" was never issued. There is good reason to believe that Beatty intended to issue it to the Naval Staff College and certain senior officers, but that he was dissuaded from doing so by the remainder of the Board of Admiralty, on the ground that it would arouse controversy—which is what the Dewars had intended it to do. In 1928, soon after succeeding Beatty, Admiral Sir Charles Madden solved the problem by consigning all available copies to the incinerator. A few, however, have survived.")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Unpublished primary source material (for the use of which I am grateful to the owners or custodians noted parenthetically in each case) yielded new material of value for both Jutland and after, viz.:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Admiralty MSS.")]), _vm._v(" (Public Record Office). (On 1 April 1964 the Admiralty became Ministry of Defence, Navy Department.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Balfour MSS.")]), _vm._v(" (The British Library). Official correspondence of Arthur Balfour, First Lord of the Admiralty, May 1915–December 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Beatty MSS.")]), _vm._v(" (Second Earl Beatty). Papers and correspondence of the Vice-Admiral Commanding Battle Cruiser Fleet, March 1913-November 1916. [Third Earl Beatty],")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Cowan MSS.")]), _vm._v(" (National Maritime Museum, Greenwich). The papers of Admiral of the Fleet Sir Walter Cowan, Bt., which contain a few letters of interest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Duff MSS.")]), _vm._v(" (Lady Duff). Grand Fleet diary of A. L. Duff, Rear-Admiral, 4th Battle Squadron, at Jutland. [National Maritime Museum, Greenwich.]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Evan-Thomas MSS.")]), _vm._v(" (Vice-Admiral Sir Geoffrey Barnard and Mr. Mervyn Bourdillon). Correspondence of Hugh Evan-Thomas, Rear-Admiral Commanding 5th Battle Squadron at Jutland. [The British Library.]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Frewen MSS.")]), _vm._v(" (Post-war Jellicoe letters on Jutland, the British Library; wartime and post-war diaries, Mrs. Lena Frewen). Lieutenant Oswald Frewen (in "), _c('i', [_vm._v("Calliope")]), _vm._v(", 4th L.C.S., at Jutland) assisted Harper in preparing the official Admiralty account of Jutland.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('i', [_vm._v("German Ministry of Marine MSS.")]), _vm._v(" (Naval Historical Branch, Ministry of Defence; now with the Bundesarchiv-Militärarchiv Militärgeschichtliches Forschungsamt in Freiburg im Breisgau); ")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("the papers of Admiral Magnus von Levetzow, who was (as a captain) the Chief of the Operations Section on Scheer’s staff at the time of Jutland, include some interesting post-war material on the battle. The Militärgeschichtliches Forschungsamt kindly made available all the post-Jutland reports of Admirals Scheer and Hipper.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Godfrey MSS.")]), _vm._v(" (Admiral John H. Godfrey). Papers supplementing his Jutland lectures at the Naval Staff College. [Naval Historical Library, Ministry of Defence.]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Hamilton MSS.")]), _vm._v(" (National Maritime Museum). 1915–16 diary and correspondence of the Second Sea Lord of 1913–17, Vice-Admiral Sir Frederick Hamilton.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Harper MSS.")]), _vm._v(" (Royal United Service Institution). Correspondence of Captain (afterwards Vice-Admiral) J. E. T. Harper pertaining to his preparation of the official Admiralty ‘Record’ of Jutland. [The British Library.]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Jackson MSS.")]), _vm._v(" (Naval Historical Branch, Ministry of Defence). Official correspondence of Admiral Sir Henry Jackson, First Sea Lord, May 1915–December 1916. [Naval Historical Library.]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Jellicoe MSS.")]), _vm._v(" (The British Library). Assorted material, notably the Admiral’s recently (August 1963) de-reserved critiques of the Admiralty "), _c('i', [_vm._v("Narrative of the Battle of Jutland")]), _vm._v(" (supplementary to his criticisms in Appendix G of the "), _c('i', [_vm._v("Narrative)")]), _vm._v(" and of Sir Winston Churchill’s Jutland account in Volume iii of his "), _c('i', [_vm._v("The World Crisis.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Keyes MSS.")]), _vm._v(" (The Dowager Lady Keyes). The papers of Admiral of the Fleet Lord Keyes (Roger Keyes), which include Jutland oddments. [Churchill College, Cambridge.]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Lennoxlove MSS.")]), _vm._v(" (The Duke of Hamilton). The Fisher papers, which include a few sidelights on Jutland and after. [Churchill College.]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Roskill MSS.")]), _vm._v(" (Captain S. W. Roskill). Valuable unpublished papers of, and correspondence with, officers who were at the Admiralty or with the Grand Fleet during Jutland.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Sturdee MSS.")]), _vm._v(" (Captain W. D. M. Staveley). Correspondence and miscellaneous papers of Sir Doveton Sturdee, Vice-Admiral Commanding 4th Battle Squadron at Jutland.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Tyrwhitt MSS.")]), _vm._v(" (Lady Agnew). Family correspondence of Admiral of the Fleet Sir Reginald Yorke Tyrwhitt, Bt., who commanded the Harwich Force throughout the war.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('i', [_vm._v("Windsor MSS.")]), _vm._v(" (Royal Archives, Windsor Castle). The papers ")]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("of King George V contain correspondence with senior admirals and other naval material.")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Various officers favoured me with unrecorded facts and personal experiences and impressions: on Jutland—Vice-Admiral Sir Geoffrey Barnard, a nephew of Admiral Sir Hugh Evan-Thomas; Rear-Admiral H. E. Dannreuther, Gunnery Officer of the battle cruiser "), _c('i', [_vm._v("Invincible]")]), _vm._v(" and Captain H. C. B. Pipon, who was in the "), _c('i', [_vm._v("Temeraire")]), _vm._v(" (4th Battle Squadron) at Jutland and served as an assistant to Captain Harper in 1919–20, when the latter was preparing the official record of the battle; on the 19 August operation—Vice-Admiral Bertram C. Watson, who was Tyrwhitt’s Navigating Officer; and, on Jutland and after, the officers mentioned below who read the manuscript.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("Those who read the manuscript in its entirety were Admiral Sir William James, who was Sturdee’s Flag-Commander in the 4th Battle Squadron, Admiral Sir Reginald Plunkett-Ernle-Erle-Drax, Beatty’s Flag-Commander and responsible for the operational staff work in the "), _c('i', [_vm._v("Lion;")]), _vm._v(" Vice-Admiral Sir Geoffrey Blake, Gunnery Officer of Jellicoe’s flagship, the "), _c('i', [_vm._v("Iron Duke;")]), _vm._v(" Rear-Admiral W. S. Chalmers, Beatty’s official biographer and a member of his staff from August 1915 until after the war; Captain John Creswell, one-time Director of the Tactical School (who also loaned me his fine Naval Staff College lecture of 1931, ‘The Operations of 19th August, 1916’); Captain S. W. Roskill; Lieutenant-Commander P. K. Kemp, Head of Naval Historical Branch and Naval Librarian, Ministry of Defence; and Commander M. G. Saunders, formerly of the Naval Historical Branch. Admiral of the Fleet Lord Chatfield, Beatty’s Flag-Captain, and Vice-Admiral Sir James A. G. Troup, Director of the Tactical School after the war, when the final Jutland demonstrations were being prepared, read ")]), _c('a', {
    attrs: {
      "href": "#/14_ch1"
    }
  }, [_vm._v("Chapters I")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/18_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")]), _vm._v(". Admiral Sir Arthur Peters, who was Goodenough’s Signal Officer in the "), _c('i', [_vm._v("Southampton")]), _vm._v(", read "), _c('span', {
    attrs: {
      "href": "#/22_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters VII")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/25_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")]), _vm._v(", and was also helpful on certain tactical problems elsewhere. To all these gentlemen, for their constructive comments and interesting sidelights, my warm thanks—and absolution for all the errors, whether of fact or interpretation, that remain in this volume.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Captain Creswell I am particularly grateful also for his detailed work in the planning and oversight of the charts in this volume; the charting of the Battle of Jutland called for a critical "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("study of the numerous charts in both the British and the German official histories, together with other material, and the production of newly-compiled charts in which clarity would be balanced against the need to provide all relevant information for the reader. For the finished drawings (including the diagrams in the text) I am grateful, as before, to Mr. N. Atherton, formerly of the Hydro-graphic Department, Ministry of Defence, and Miss G. Savage and colleagues, of that Department.")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I am also grateful to the University of Hawaii and to the University of California, Irvine, for financial assistance and teaching-load reductions; the American Philosophical Society, for financial assistance; Vice-Admiral Sir Peter Gretton, late Deputy Chief of Naval Staff and Fifth Sea Lord, for assistance in a myriad of ways; the Dowager Countess Jellicoe, for permitting me to see post-Jutland letters from the Admiral, also those from Admiral Sir Charles Madden (alas, little of Jellicoe’s family correspondence has survived); Dr. Carl Stroven, Librarian of the University of Hawaii, and Mr. John Smith, Librarian of the University of California, Irvine, and their most competent staffs, for handling countless requests with dispatch; Commander Kemp and that valiant, undermanned band in the Naval Historical Branch and the Naval Library, for so patiently putting up with my constant harassment; Admiral Sir Geoffrey Oliver, Vice-Admirals Sir Francis Pridham and J. C. W. Henley, Captain L. E. H. Llewellyn, and Commander R. T. Young, for clarifying various points concerned with British gunnery and naval ordnance; Vice-Admiral Sir Aubrey Mansergh, the same "), _c('i', [_vm._v("re")]), _vm._v(" torpedoes; Commander W. B. Rowbotham, for help with a number of problems; Lieutenant-Commander D. W. Waters, of the National Maritime Museum, for helping to keep me straight on U-boat and trade-defence matters; Mr. L. J. Gorton, Deputy Keeper of the Department of Manuscripts, British Museum, for solving some puzzles in the Jellicoe MSS.; Mr. Peter Fellows and the rest of the magnificent staff of the Long Room at the Public Record Office, for co-operation well beyond the call of duty; and, finally and indispensably, Mrs. Violet Borges and Mrs. Judith Tokunaga, of the University of Hawaii, for their incomparable secretarial work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wish to thank the following publishers for their kind permission to quote from the copyright material indicated:")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Cassell & Co., Ltd. (and, for the first title, Curtis Brown, Ltd., and, for the second, Putnam’s & Coward-McCann, Inc.), from Admiral of the Fleet Lord Jellicoe’s "), _c('i', [_vm._v("The Grand Fleet, 1914–16")]), _vm._v(", Langhorne Gibson and Vice-Admiral J. E. T. Harper’s "), _c('i', [_vm._v("Riddle of Jutland")]), _vm._v(", and Admiral Sir Reginald Bacon’s "), _c('i', [_vm._v("The Life of John Rushworth, Earl Jellicoe;")]), _vm._v(" Christy & Moore, Ltd., from Admiral Sir William Goodenough’s "), _c('i', [_vm._v("A Rough Record;")]), _vm._v(" the Executors of the estate of Admiral Sir Frederic Dreyer, from the latter’s "), _c('i', [_vm._v("The Sea Heritage;")]), _vm._v(" Victor Gollancz, Ltd. and Vice-Admiral K. G. B. Dewar, from the latter’s "), _c('i', [_vm._v("The Navy from Within;")]), _vm._v(" William Heine-mann, Ltd., from Admiral of the Fleet Lord Chatfield’s "), _c('i', [_vm._v("The Navy and Defence;")]), _vm._v(" Her Majesty’s Stationery Office, from Sir Julian Corbett and Sir Henry Newbolt’s "), _c('i', [_vm._v("History of the Great War. Naval Operations;")]), _vm._v(" Hodder & Stoughton, Ltd. and Rear-Admiral W. S. Chalmers, from the latter’s "), _c('i', [_vm._v("The Life and Letters of David, Earl Beatty;")]), _vm._v(" Sampson Low, Marston & Co., Ltd., from Captain John Creswell’s "), _c('i', [_vm._v("Naval Warfare;")]), _vm._v(" E. S. Mittler & Sohn, from Captain Otto Groos’s "), _c('i', [_vm._v("Der Krieg zur See, 1914–1918. Der Krieg in der Nordsee;")]), _vm._v(" John Murray (Publishers) Ltd., from C. Ernest Fayle’s "), _c('i', [_vm._v("History of the Great War. Seaborne Trade;")]), _vm._v(" Frederick Muller, Ltd., from Admiral Sir Reginald Bacon and Francis McMurtrie’s "), _c('i', [_vm._v("Modern Naval Strategy;")]), _vm._v(" Odhams Press Ltd. and Charles Scribner’s Sons, from Sir Winston Churchill’s "), _c('i', [_vm._v("The World Crisis;")]), _vm._v(" the Royal United Service Institution, from Vice-Admiral Craig Waller’s article, ‘The Fifth Battle Squadron at Jutland’, in the November 1935 "), _c('i', [_vm._v("Journal of the Royal United Service Institution.")]), _vm._v(" Unpublished Crown copyright material in the Public Record Office is published by permission of the Controller of Her Majesty’s Stationery Office. I would also like to express my appreciation of the privilege which I owe to Vice-Admiral Sir Francis Pridham and the late Vice-Admiral K. G. B. Dewar of quoting from certain of their restricted writings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In conclusion, a list of the abbreviations (official or unofficial) that occur in the text follows:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("A.C.N.S.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "3%"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "77%"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Assistant Chief of Naval Staff")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("A.P. shell")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Armour-piercing shell")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("B.C.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Battle Cruiser")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("B.C.F.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Battle Cruiser Fleet")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("B.C.S.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Battle Cruiser Squadron")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("B.F.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Battle Fleet")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("B.S.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Battle Squadron")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Captain (D)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Captain commanding a destroyer flotilla")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("C.O.S.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Chief of the Admiralty War Staff (also Chief of Staff to a Flag Officer Commanding)")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("C.S.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Cruiser Squadron")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("D.C.N.S.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Deputy Chief of Naval Staff")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("D.N.C.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Director of Naval Construction")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("D.N.I.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Director of Naval Intelligence"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#pre_fn2",
      "id": "not_2"
    }
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("D.N.O.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Director of Naval Ordnance")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("D.O.D.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Director of the Operations Division, Admiralty War Staff")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("G.F.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Grand Fleet")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("G.F.B.O.s")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Grand Fleet Battle Orders")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("L.C.S.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Light Cruiser Squadron")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("(N)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Navigation—a specialist qualification")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("N.I.D.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Naval Intelligence Division, Admiralty")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("R.F.C.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Royal Flying Corps")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("R.N.A.S.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Royal Naval Air Service"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#pre_fn3",
      "id": "not_3"
    }
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("S.G.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("(German) Scouting Group")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("S.M.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Submarine")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("T.B.D.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("[Torpedo Boat] Destroyer")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("V/S")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Visual signalling")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("W/T")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Wireless telegraphy")])])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "align": "left"
    }
  }, [_c('i', [_vm._v("Irvine, California")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTHUR")]), _vm._v(" J. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARDER")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', [_vm._v("   January 1965")])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('i', [_vm._v("Note")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Especially helpful in the preparation of the second impression was Commander W. M. Phipps Hornby, who served in the "), _c('i', [_vm._v("Chester")]), _vm._v(" at Jutland.")]), _vm._v(" "), _c('p', {
    staticClass: "note1"
  }, [_vm._v("A.J.M.")]), _vm._v(" "), _c('p', {
    staticClass: "note2"
  }, [_c('i', [_vm._v("Irvine, California")])]), _vm._v(" "), _c('p', {
    staticClass: "note3"
  }, [_c('i', [_vm._v("July 1966")])])]), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('sup')]), _c('a', {
    attrs: {
      "href": "#/#not_1",
      "id": "pre_fn1"
    }
  }, [_vm._v("*")]), _vm._v(" For this new edition I have updated the locations of collections of papers by adding the new location in square brackets, and made a few other minor changes.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#not_2",
      "id": "pre_fn2"
    }
  }, [_vm._v("*")])]), _vm._v(" The title of pre-War Staff days (–1912), revived in 1918. As in Volume ii, I use this in place of ‘D.I.D.’ (Director of the Intelligence Division of the War Staff), which was the official title, 1912–18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#not_3",
      "id": "pre_fn3"
    }
  }, [_vm._v("†")])]), _vm._v(" Merged with the R.F.C. (Royal Flying Corps) to become the R.A.F on 1 April 1918.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-546d4042","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_preface.vue
// module id = 75
// module chunks = 0